"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = void 0;
const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber) {
        const l = phoneNumber.length;
        const prefix = phoneNumber.slice(0, l - 10);
        const areaCode = phoneNumber.slice(l - 10, l - 7);
        const firstThree = phoneNumber.slice(l - 7, l - 4);
        const lastFour = phoneNumber.slice(l - 4);
        return `${prefix} (${areaCode}) ${firstThree}-${lastFour}`.trim();
    }
    return '';
};
exports.formatPhoneNumber = formatPhoneNumber;
//# sourceMappingURL=phone.js.map